import React, { useEffect, useState } from 'react';
import { useTranslate } from '@im/react-localization';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { WarehouseDetails } from '../../internal/common.types';

type Props = {
  fromPage: string;
  stockStatus: string;
  warehouseStockDetail?: any;
};

export default function WarehouseETAVendorBHODirectShip(prop: Props) {
  const translate = useTranslate();
  const { fromPage, stockStatus, warehouseStockDetail } = prop;
  const [vendorBohQuantityValue, setVendorBohQuantityValue] = useState(0);
  useEffect(() => {
    if (
      fromPage === 'product' &&
      warehouseStockDetail?.warehouseDetails?.find(
        (item: WarehouseDetails) => item?.name === 'VENDOR WAREHOUSE**'
      )
    ) {
      const vendorBohQuantity =
        warehouseStockDetail?.warehouseDetails !== null &&
        warehouseStockDetail?.warehouseDetails !== undefined &&
        warehouseStockDetail?.warehouseDetails?.find(
          (item: WarehouseDetails) => item?.name === 'VENDOR WAREHOUSE**'
        )?.quantityAvailable;
      setVendorBohQuantityValue(vendorBohQuantity);
    } else if (
      fromPage === 'productdetails' &&
      warehouseStockDetail?.find(
        (item: any) => item?.warehouseDescription === 'VENDOR WAREHOUSE**'
      )
    ) {
      const vendorBohQuantity =
        warehouseStockDetail !== null &&
        warehouseStockDetail !== undefined &&
        warehouseStockDetail.find(
          (item: any) => item?.warehouseDescription === 'VENDOR WAREHOUSE**'
        )?.warehouseAvailableQuantity;
      setVendorBohQuantityValue(vendorBohQuantity);
    } else if (
      fromPage === 'cart' &&
      warehouseStockDetail?.find(
        (item: any) => item?.warehouseDescription === 'VENDOR WAREHOUSE**'
      )
    ) {
      const vendorBohQuantity =
        warehouseStockDetail !== null &&
        warehouseStockDetail !== undefined &&
        warehouseStockDetail.find(
          (item: any) => item?.warehouseDescription === 'VENDOR WAREHOUSE**'
        )?.quantity;
      setVendorBohQuantityValue(vendorBohQuantity);
    }
  }, [fromPage, warehouseStockDetail]);

  return (
    <>
      {Number(vendorBohQuantityValue) > 0 ? (
        <>
          <Tooltip
            arrow
            placement="top"
            title={translate('Warehouse.BHOTooltips', {
              vendorBohQuantityValue: vendorBohQuantityValue.toString(),
            })}
          >
            <Typography
              color={'#054F31'}
              component="span"
              sx={{
                borderRadius: '16px',
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '16px',
              }}
              variant="body2"
            >
              {fromPage !== 'cart' ? (
                <>
                  <Typography
                    component="span"
                    sx={{ fontSize: '12px', fontWeight: '600' }}
                  >
                    {vendorBohQuantityValue}
                  </Typography>{' '}
                  {translate(`Common.${stockStatus}`)}
                </>
              ) : (
                <>
                  <Typography
                    component="span"
                    sx={{ fontSize: '12px', fontWeight: '600' }}
                  >
                    ${vendorBohQuantityValue}{' '}
                  </Typography>{' '}
                  {translate('Cart.DirectShip')}
                </>
              )}
            </Typography>
          </Tooltip>
        </>
      ) : (
        <>
          <Tooltip
            arrow
            placement="top"
            title={translate('Warehouse.BHOTooltipsText')}
          >
            {fromPage !== 'cart' ? (
              <Typography
                color={stockStatus === 'Outofstock' ? '#B11616' : '#054F31'}
                component="span"
                sx={{
                  borderRadius: '16px',
                  display: 'inline-flex',
                  fontFamily: 'Roboto',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '16px',
                }}
                variant="body2"
              >
                {translate(`Common.${stockStatus}`)}
              </Typography>
            ) : (
              <Typography
                color="#054F31"
                component="span"
                sx={{
                  borderRadius: '16px',
                  display: 'flex',
                  fontFamily: 'Roboto',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '16px',
                }}
                variant="body2"
              >
                {translate('Cart.DirectShip')}
              </Typography>
            )}
          </Tooltip>
        </>
      )}
    </>
  );
}
